__turbopack_context__.v({
  "buttonGroupLeft": "top-panel-module-scss-module__leK-da__buttonGroupLeft",
  "buttonGroupRight": "top-panel-module-scss-module__leK-da__buttonGroupRight",
  "checkBoxMenuOption": "top-panel-module-scss-module__leK-da__checkBoxMenuOption",
  "checkBoxMenuOptions": "top-panel-module-scss-module__leK-da__checkBoxMenuOptions",
  "container": "top-panel-module-scss-module__leK-da__container",
  "desktopContainer": "top-panel-module-scss-module__leK-da__desktopContainer",
  "metLogo": "top-panel-module-scss-module__leK-da__metLogo",
  "metLogoWrapper": "top-panel-module-scss-module__leK-da__metLogoWrapper",
  "mobileContainer": "top-panel-module-scss-module__leK-da__mobileContainer",
  "spinner": "top-panel-module-scss-module__leK-da__spinner",
  "spinnerWrapper": "top-panel-module-scss-module__leK-da__spinnerWrapper",
  "title": "top-panel-module-scss-module__leK-da__title",
  "titleWrapper": "top-panel-module-scss-module__leK-da__titleWrapper",
  "tooltipContent": "top-panel-module-scss-module__leK-da__tooltipContent",
});
